import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import service from '../../services';
import useUserStore from '../../stores/UserStore';
import useWorkspaceStore from '../../stores/WorkspaceStore';

const PluginIndex = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser, user } = useUserStore((state) => ({
    setUser: state.setUser,
    user: state.user,
  }));
  const { currWorkspace, workspaces, fetchWorkspace, fetchWorkspaces } =
    useWorkspaceStore((state) => ({
      currWorkspace: state.currWorkspace,
      workspaces: state.workspaces,
      fetchWorkspace: state.fetchWorkspace,
      fetchWorkspaces: state.fetchWorkspaces,
    }));

  const wa = currWorkspace?.alias;

  useEffect(() => {
    const checkStorage = (): string | false => {
      if (user) {
        const alias = localStorage.getItem(`curr_workspace_${user.user_id}`);
        return alias || false;
      }
      return false;
    };

    const request = (alias: string) => {
      navigate(`/request-access/${alias}`, { replace: true });
    };

    if (user) {
      if (user.hasWorkspace && workspaces.length === 0) {
        fetchWorkspaces();
        return;
      }
      const alias = checkStorage();
      if (alias) {
        fetchWorkspace(alias, () => request(alias));
      } else {
        fetchWorkspace(workspaces[0].alias, () => request(workspaces[0].alias));
      }
    } else {
      (async () => {
        const data = await service.auth.authCheck();
        if (data && data.workspaces?.length) {
          setUser({
            user_id: data.user_id,
            firstName: data.first_name,
            lastName: data.last_name,
            email: data.email,
            hasWorkspace: true,
            color: data.color,
          });
        } else {
          navigate('/login', { replace: true });
        }
      })();
    }
  }, [
    user,
    navigate,
    setUser,
    workspaces,
    fetchWorkspaces,
    fetchWorkspace,
    location.pathname,
  ]);

  useEffect(() => {
    if (location.pathname !== '/') return;
    if (wa) {
      navigate(`/workspace/${wa}`);
    }
  }, [wa, navigate, location.pathname]);

  return null;
};

export default PluginIndex;
